import { defineComponent as _defineComponent } from 'vue'
import { useViewport } from '@travelata-libs/utils';
import { isWithinInterval } from 'date-fns';
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCertificatesBanner',
  props: {
  link: {
    type: String,
    default:
        'https://gift.travelata.ru/?utm_source=travelata&utm_medium=banner&utm_campaign=gift_certificates&utm_content=main',
  },
  openInNewTab: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: 'Чтобы подарок ',
  },
  titleWrapping: {
    type: String,
    default: 'не пылился на полке',
  },
  subtitle: {
    type: String,
    default: 'Сертификат на отдых — лучший сюрприз для близких',
  },
  buttonText: {
    type: String,
    default: 'Выбрать сертификат',
  },
  isSearchPage: {
    type: Boolean,
    default: false,
  },
  showDiscountBanner: {
    type: Boolean,
    default: false,
  }
} as const,
  setup(__props) {

const props = __props



const { isMobile } = useViewport();

const openLinkCertificates = () => {
  if (props.openInNewTab) {
    window.open(props.link, '_blank', 'noopener');
  } else {
    window.location.href = props.link;
  }
}

const inDiscountDateRange = computed(() => {
  const startDate = new Date(Date.UTC(2026, 1, 3, 0, 1));
  const endDate = new Date(Date.UTC(2026, 1, 15, 23, 59, 59, 999));

  const now = new Date();

  return isWithinInterval(now, { start: startDate, end: endDate });
});

const shouldShowDiscountBanner = computed(() => inDiscountDateRange.value && props.showDiscountBanner);
const isMobileSearchPage = computed(() => isMobile.value && props.isSearchPage);

return { __sfc: true,props, isMobile, openLinkCertificates, inDiscountDateRange, shouldShowDiscountBanner, isMobileSearchPage }
}

})